<template>
     <div class="link-container">
      <el-link href="https://shimo.im/sheets/m4kMMZ7r1LCWVKkD/XPLdO" target="_blank" type="primary">浙商</el-link>
      <el-link href="https://gtjafxgl.feishu.cn/wiki/P8iNwNPLxiUbgakkyoJcYdCNn6d" target="_blank" type="primary">国君</el-link>
      <el-link href="https://galaxyderivatives.feishu.cn/sheets/SVy2sNldHh5zIhtZfBHc9X1ln0c" target="_blank" type="primary">银河</el-link>
      <el-link href="https://www.kdocs.cn/l/cgYgJIqIMsMK" target="_blank" type="primary">光大</el-link>
      <el-link href="https://tradelink.cicc.com/login" target="_blank" type="primary">中金</el-link>
      <el-link href="https://goats.gf.com.cn/#/home" target="_blank" type="primary">广发</el-link>
      <el-link href="https://eqd.cs.ecitic.com/eqdweb/user/logon/" target="_blank" type="primary">中信证券</el-link>
     <el-link href="http://localhost:8000/gf" target="_blank" type="primary">拉取广发期权</el-link>

     <!-- 编码后的飞书授权链接 -->
     <el-link
       :href="feishuAuthUrl"
       target="_blank"
       type="primary"
       @click="handleFeishuAuth"
     >
       飞书授权
     </el-link>
    </div>
    <h1>上传文件</h1>
    <el-card class="drop-area" shadow="hover" :class="{ 'drag-over': isDragging }" @dragenter.prevent="dragEnter" @dragleave.prevent="dragLeave" @drop.prevent="handleDrop">
      <div class="drop-message">
        <p v-if="!isDragging">将文件拖放到此处或点击选择文件</p>
        <p v-else>释放文件以上传</p>
      </div>
      <input
        type="file"
        @change="handleFileChange"
        multiple
        ref="fileInput"
        class="file-input"
      />
    </el-card>
    <div v-if="files.length" class="file-list">
      <div v-for="(file, index) in files" :key="index" class="file-item">
        <span>{{ file.name }}</span>
        <el-button @click="removeFile(index)" type="danger" size="small">移除</el-button>
      </div>
    </div>
    <el-button v-if="files.length" @click="uploadFiles" type="primary" class="upload-button">上传</el-button>
    <div v-if="uploadStatus" class="upload-status" :class="uploadStatus.type">
      <p>{{ uploadStatus.message }}</p>
    </div>


    <div class="form-container">
      <label class="label">选择日期:</label>
      <el-date-picker
        v-model="date"
        type="date"
        placeholder="选择日期"
        :default-value="new Date()"
        @change="fetchData"
        class="date-picker"
      ></el-date-picker>


    </div>
    <div class="form-container">
      <!-- 添加机构选择器 -->
      <label class="label">选择机构:</label>
      <el-select v-model="selectedAgency" placeholder="请选择机构" class="agency-select">
        <el-option
          v-for="item in agencyList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
         <el-button @click="etf_list" type="primary" class="etf-list-button" :loading="isLoading">
          <el-icon><Coin /></el-icon> 更新【{{ selectedAgency }}】 期权
        </el-button>
    </div>
    <div class="button-container">

        <el-button @click="processData" type="primary" class="update-stock-button">
          <el-icon><Edit /></el-icon> 处理数据
        </el-button>
        <el-button @click="deleteData" type="danger" class="update-stock-button">
          <el-icon><Delete /></el-icon> 删除数据
        </el-button>


        <el-button @click="updateStock" type="success" class="update-stock-button">
          <el-icon><Refresh /></el-icon> 更新股票标的
        </el-button>
        <el-button @click="hot_list" type="warning" class="hot-list-button">
          <el-icon><Ranking /></el-icon> 生成龙虎榜
        </el-button>

        <el-button @click="text_list" type="info" class="text-list-button">
          <el-icon><Document /></el-icon> 中金期权
        </el-button>



        <el-button @click="day_search" type="success" class="day-search-button">
          <el-icon><Upload /></el-icon> 涨停入库
        </el-button>
        <el-button @click="export2Db" type="danger" class="export2db-button">
          <el-icon><Download /></el-icon> 龙虎榜(游资)
        </el-button>
        <el-button @click="merge_excel_file" type="info" class="text-list-button" >
          <el-icon><Download /></el-icon> 合并文件
        </el-button>
    </div>

</template>

<script>
import axios from 'axios';
import { formatDate } from '@/utils/commonMethods';
import { ElMessage, ElButton, ElIcon, ElLink, ElCard, ElSelect, ElOption } from 'element-plus';

export default {
  name: 'ToolsPage',
  components: {
    ElButton,
    ElIcon,
    ElLink,
    ElCard,
    ElSelect,
    ElOption,
  },
  data() {
    return {
      date: new Date(),
      files: [],
      uploadStatus: null,
      isDragging: false,
      isLoading: false, // 添加loading状态变量
      // 添加机构选择相关变量
      agencyList: [
        { label: '广发', value: '广发' },
        { label: '广发本地', value: '广发本地' },
        { label: '中金', value: '中金' },
        { label: '国君', value: '国君' },
        { label: '银河', value: '银河' },
        { label: '光大', value: '光大' },
        { label: '浙商', value: '浙商' },
        { label: '中信中证', value: '中信中证' },
        { label: '中信证券', value: '中信证券' }
      ],
      selectedAgency: '广发本地' // 默认选择广发
    };
  },
  computed: {
    formattedDate() {
      return this.date ? formatDate(this.date) : '';
    },
    // 计算属性：生成编码后的飞书授权URL
    feishuAuthUrl() {
      const clientId = 'cli_a67fa7101f0c500c'
      const redirectUri = encodeURIComponent('https://admin.58option.cn/callback')
      const scope = encodeURIComponent('contact:contact.base:readonly')
      const state = 'state123'
      return `https://open.feishu.cn/open-apis/authen/v1/authorize?app_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&state=${state}`
    }
  },
  methods: {
    // 处理飞书授权点击
    handleFeishuAuth() {
      // 可以在这里添加一些前置处理逻辑
      console.log('开始飞书授权流程')
      // 链接已经在href中设置，浏览器会自动跳转
    },
    async export2Db() {
      console.log('开始请求数据:', this.questionQuery);
      try {
        const responses = await axios.get(`/api/export2db`);
        const responseData = responses.data;
        this.stockData = responseData;
        ElMessage.success(responseData.data);
        console.log('所有请求完成:', this.stockData); // 添加调试信息
      } catch (error) {
        ElMessage.error('请求失败:', error);
        console.error('请求失败:', error);
      }
    },
    async merge_excel_file() {
      console.log('开始合并请求:', this.questionQuery);
      try {
        const responses = await axios.post(`/api/merge-excel`);
        const responseData = responses.data.message;
        ElMessage.success(responseData.length + '条');
        console.log('所有请求完成:',responseData); // 添加调试信息
      } catch (error) {
        ElMessage.error('请求失败:', error);
        console.error('请求失败:', error);
      }
    },
    async day_search() {
      try {
        const response = await axios.get(`/api/day_search`);
        const responseData = response.data;
        if (responseData.data == 0) {
          ElMessage.error('没有找到相关数据');
        } else {
          ElMessage.success('操作成功,新增数据:' + responseData.data + '条');
        }
      } catch (error) {
        console.error('数据获取失败:', error);
        ElMessage.error('数据获取失败，请检查网络连接或服务器状态。'+error);
      } finally {
        console.log('请求完成');
      }
    },
    async processData() {
      console.log('开始请求数据:', this.questionQuery);
      try {
        const now_date = this.date;
        console.log('当前时间:', now_date);
        const responses = await axios.get(`/api/processData`, { params: { now_date: this.formattedDate } });
        const data = responses.data;
        if (data) {
          ElMessage.success(JSON.stringify(data.is_ok));
          ElMessage.error(JSON.stringify(data.error));
        }

      } catch (error) {
        console.error('请求失败:', error);
      }
    },
    async deleteData() {
      console.log('开始请求数据:', this.questionQuery);
      try {
        const now_date = this.date;
        console.log('当前时间:', now_date);
        const responses = await axios.get(`/api/deleteData`, { params: { now_date: this.formattedDate } });
        const responseData = responses.data;
        console.info(responseData);
        ElMessage.success(responseData.message);
        console.log('所有请求完成:', responseData); // 添加调试信息
      } catch (error) {
        console.error('请求失败:', error);
        ElMessage.error(error.response.data.detail);
      }
    },
    async updateStock() {
      try {
        const response = await axios.get(`/api/update_stock_list`);
        this.wcData = response.data;
        const responseData = response.data;
        ElMessage.success(responseData.data);
        console.info(this.wcData);
      } catch (error) {
        console.error('请求失败:', error);
      }
    },
    async hot_list() {
      try {
        const response = await axios.get(`/api/hot_list`);
        this.wencaiData = response.data;
        console.info(this.wencaiData);
      } catch (error) {
        console.error('请求失败:', error);
      }
    },
    async text_list() {
      console.log('开始请求数据:', this.questionQuery);
      try {
        const responses = await axios.get(`/api/zj`);
        const responseData = responses.data;
        this.wencaiData = responseData;
        console.log('所有请求完成:', this.wencaiData); // 添加调试信息
      } catch (error) {
        console.error('请求失败:', error);
      }
    },
   async etf_list() {
  console.log('开始请求数据:', this.questionQuery);

  // 设置loading状态为true
  this.isLoading = true;

  try {
    let responseData;

    // 添加判断逻辑：如果field等于"广发本地"，直接打开一个新窗口访问地址http://localhost:8000/gf
    if (this.selectedAgency === '广发本地') {
      // 使用window.open打开新窗口
      window.open('http://localhost:8000/gf', '_blank', 'noopener,noreferrer');
      ElMessage.success('已打开新窗口');
    } else {
      // 其他机构继续使用原有的/api/SingaProcessData接口
      const responses = await axios.get(`/api/SingaProcessData`, {
        params: {
          now_date: this.formattedDate,
          field: this.selectedAgency // 使用用户选择的机构
        }
      });
      responseData = responses.data;

      if (responseData.code === 200) {
        ElMessage.success(responseData.message);
      } else {
        ElMessage.error(responseData.message);
      }
    }
  } catch (error) {
    console.error('请求失败:', error);
    ElMessage.error('请求失败: ' + (error.response?.data?.message || error.message));
  } finally {
    // 请求完成后，无论成功或失败，都将loading状态设置为false
    this.isLoading = false;
  }
},
    handleFileChange(event) {
      this.files = Array.from(event.target.files);
    },
    handleDrop(event) {
      this.files = Array.from(event.dataTransfer.files);
      this.isDragging = false;
    },
    dragEnter() {
      this.isDragging = true;
    },
    dragLeave() {
      this.isDragging = false;
    },
    removeFile(index) {
      this.files.splice(index, 1);
    },
    async uploadFiles() {
      if (this.files.length === 0) {
        this.uploadStatus = { type: 'error', message: '请选择一个文件' };
        return;
      }

      const formData = new FormData();
      this.files.forEach((file) => {
        formData.append('files', file); // 修改这里
      });

      try {
        const response = await axios.post('/api/upload_file', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${this.$store.getters.token}`
          },
        });
        this.uploadStatus = {
          type: 'success',
          message: `文件上传成功: ${response.data.filenames.join(', ')}`,
        };
        this.files = [];
      } catch (error) {
        this.uploadStatus = { type: 'error', message: `文件上传失败: ${error.message}` };
        if (error.response && error.response.data && error.response.data.detail) {
          this.uploadStatus.message += ` - ${error.response.data.detail}`;
        }
      }
    },
  },
};
</script>

<style scoped>
/* 原有样式保持不变 */


.upload-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 50px;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.link-container {
  margin-bottom: 20px;
}

.el-link {
  margin-right: 10px;
  font-weight: bold;
  color: #409EFF;
}

.el-link:hover {
  color: #66b1ff;
}

h1 {
  font-size: 24px;
  color: #333;
  margin-bottom: 20px;
}

.drop-area {
  width: 100%;
  max-width: 400px;
  min-height: 200px;
  border: 2px dashed #409EFF;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  transition: border-color 0.3s;
}

.drop-area.drag-over {
  border-color: #66b1ff;
}

.drop-message {
  text-align: center;
  color: #666;
}

.file-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

.file-list {
  width: 100%;
  max-width: 400px;
  margin-top: 20px;
}

.file-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.upload-button {
  margin-top: 20px;
  padding: 10px 20px;
  background-color: #409EFF;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.upload-button:hover {
  background-color: #66b1ff;
}

.upload-status {
  margin-top: 20px;
  padding: 10px;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.upload-status p {
  margin: 0;
  font-size: 16px;
}

.upload-status.success {
  background-color: #dff0d8;
  color: #3c763d;
}

.upload-status.error {
  background-color: #f2dede;
  color: #a94442;
}

.form-container {
  margin-bottom: 20px;
}

.label {
  margin-right: 10px;
  font-weight: bold;
}

.date-picker {
  width: 200px;
}

/* 添加机构选择器样式 */
.agency-select {
  width: 120px;
}

.button-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.button-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.el-button {
  width: 150px;
}

@media (max-width: 768px) {
  .container {
    padding: 10px;
  }

  .form-container {
    margin-bottom: 10px;
  }

  .button-container {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }

  .button-group {
    flex-direction: row;
    gap: 10px;
  }

  .el-button {
    width: 100%;
  }
}
</style>
